export const CANCEL_BTN_TEXT = 'Cancel'
export const DELETE_BTN_TEXT = 'Delete'
